import type { DraggableSkillData } from "@/dnd/ids";
import type { Skill } from "@cohesive/api-client";
import type { Entity } from "@cohesive/ui-components";

/** Drag payload for a skills-rail row — favorites + canvas placement. */
export function buildSkillsRailDragPayload(skill: Skill): DraggableSkillData {
  // Skill API types use plain strings; Entity skill data expects literal unions.
  const entities = [
    {
      type: "skill",
      platform: "cohesive",
      data: {
        id: skill.id,
        name: skill.name,
        description: skill.description,
        type: skill.type,
        status: skill.status,
        icon: skill.icon,
      },
    },
  ] as Entity[];

  return {
    kind: "skill",
    skillIds: [skill.id],
    primaryName: skill.name,
    entities,
  };
}
